import { render } from "./LastRaceResult.vue?vue&type=template&id=1cc523d1"
import script from "./LastRaceResult.vue?vue&type=script&lang=js"
export * from "./LastRaceResult.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__